export function isFieldRestricted(idField, restrictedList) {
 if(idField === undefined) return false;
  if(idField.includes("productPackage")){
    return false;
  }
  return restrictedList.some(restricted => {
    // Case 1: direct substring match (e.g. .address.internalLabel["@none"])

    if (idField.includes(restricted)) {
      return true;
    }

    // Case 2: normalize dynamic indexes
    // - Convert [0], [12] in idField → []
    const normalizedId = idField.replace(/\[\d+\]/g, "[]");

    // - Convert [${i}], [${m}] in restricted → []
    const normalizedRestricted = restricted.replace(/\[\$\{[a-z]\}\]/gi, "[]");

    return normalizedId.endsWith(normalizedRestricted);
  });
}
